// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import MinusRoundSvg from '@rsuite/icon-font/lib/status/MinusRound';
var MinusRound = createSvgIcon({
  as: MinusRoundSvg,
  ariaLabel: 'minus round',
  category: 'status',
  displayName: 'MinusRound'
});
export default MinusRound;